<template>
  <el-container class="column" style="width:100%; height:100vh; background-color:white;">
    <div class="header row-between">
      <div class="row-start">
        <div style="color:white;box-sizing: border-box; padding: 10px 20px; background: linear-gradient(135deg, #626aef, green); border-radius:8px; box-shadow:0 0px 2px rgba(0, 0, 0, 0.1); width:max-content; margin-left:20px; border:none">ChatBI</div>
        <el-tooltip effect="dark" content="返回上一页" placement="bottom">
          <el-icon class="round-button" @click="goBack"><Back /></el-icon>
        </el-tooltip>
      </div>
      

      <div style="margin-right:10px" class="row">

        <el-select v-model="work_modes" placeholder="BI模式" style="width: 240px" class="select-input">
          <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
          />
        </el-select>
        <div v-if="store.getters.isLogined" class="row-start"  style="margin-left: 20px">
          <div style="padding:0px; background-color:#F4F4FE;width:40px; height: 40px; border-radius:50%; border: 1px solid #E4E7ED" class="row">
            <el-icon style="font-size:16px; color:#6467F0;"><UserFilled /></el-icon>
          </div>
          <div style="margin-left: 5px;">{{store.getters.username}}</div>
        </div>
        <div v-else class="row-start" style="margin-left: 20px">
          <div @click="toLoginPage"
               style="padding:0px;background-color:white;width:40px; height: 40px; border-radius:50%; border: 1px solid #E4E7ED" class="row">
            <el-icon style="font-size:16px;"><UserFilled /></el-icon>
          </div>
          <div style="margin-left: 5px; color:gray">游客</div>
        </div>
      </div>

    </div>
    <div class="mid row-between scroll-container">
      <div style="width:40%; height:100%;margin-left:30%" class="scroll-container" @scroll="handScroll" ref="contentRef">
        <div v-for="(record, index) in dialogues" :key="index">
          <div v-if="record.role === 'user'" class="row-end" style="width: 100%;margin-top:15px;">
            <div style="background-color: ghostwhite; border-radius: 15px 0px 15px 15px;padding:8px 15px">{{record.content}}</div>
          </div>
            
          <div v-if="record.role === 'query_think'" 
          style="width:100%;margin-top:10px;display:flex; flex-direction:column; justify-content:flex-start; align-items:flex-start">
            <el-button color="#6467F0" size="small" dark round>
                 <el-icon><CircleCheckFilled /></el-icon>
                 <span style="margin-left:5px">已完成联想</span>
             </el-button>
              <div v-if="record.content !== ''" class="aux-content">{{record.content}}</div>
          </div>
            
          <div v-if="record.role === 'query_match'" 
          style="width:100%;margin-top:10px;display:flex; flex-direction:column; justify-content:flex-start; align-items:flex-start">
             <el-button color="#6467F0" size="small" dark round>
                 <el-icon><CircleCheckFilled /></el-icon>
                 <span style="margin-left:5px">已完成匹配</span>
             </el-button>
             <div v-if="record.content !== ''" class="aux-content">{{record.content}}</div>
          </div>
            
          <div v-if="record.role === 'assistant'" 
          style="width:100%;margin-top:10px;display:flex; flex-direction:column; justify-content:flex-start; align-items:flex-start">
            <el-button color="#6467F0" size="small" dark round>
                 <el-icon><CircleCheckFilled /></el-icon>
                 <span style="margin-left:5px">已生成查询</span>
             </el-button>
             <div v-if="record.content !== ''" class="aux-content">{{record.content}}</div>
          </div>
        </div>

        <div class="column">
        <div v-if="query !== ''" class="row-end" style="width: 100%; margin-top:15px;">
          <div style="background-color: ghostwhite; border-radius: 15px 0px 15px 15px;padding:8px 15px">{{query}}</div>
        </div>
         <div
           style="width:100%;margin-top:10px;display:flex; flex-direction:column; justify-content:flex-start; align-items:flex-start">
          <el-button v-if="steps[0].step && !steps[0].state" color="#6467F0" size="small" style="border:none" plain loading round>查询联想中</el-button>
            <el-button v-if="steps[0].step && steps[0].state && think_content !== ''" color="#6467F0" size="small" dark round>
                <el-icon><CircleCheckFilled /></el-icon>
                <span style="margin-left:5px">已完成联想</span>
            </el-button>
          <div v-if="think_content !== ''" class="aux-content">{{think_content}}</div>
         </div>
         <div style="width:100%;margin-top:10px;display:flex; flex-direction:column; justify-content:flex-start; align-items:flex-start">
             <el-button v-if="steps[1].step && !steps[1].state" color="#6467F0" style="border:none" size="small" plain loading round>查询匹配中</el-button>
             <el-button v-if="steps[1].step && steps[1].state && match_content !== ''" color="#6467F0" size="small" dark round>
               <el-icon><CircleCheckFilled /></el-icon>
               <span style="margin-left:5px">已完成匹配</span>
             </el-button>
             <div v-if="match_content !== ''" class="aux-content">{{match_content}}</div>
         </div>
            
         <div style="width:100%;margin-top:10px;display:flex; flex-direction:column; justify-content:flex-start; align-items:flex-start">
              <el-button v-if="steps[2].step && !steps[2].state" color="#6467F0" style="border:none" size="small" plain loading round>查询生成中</el-button>
              <el-button v-if="steps[2].step && steps[2].state && sql_content !== ''" color="#6467F0" size="small" dark round>
                 <el-icon><CircleCheckFilled /></el-icon>
                 <span style="margin-left:5px">已生成查询</span>
              </el-button>
              <div v-if="sql_content !== ''" class="aux-content">{{sql_content}}</div>
         </div>
  
         <div style="width:100%;margin-top:10px;display:flex; flex-direction:column; justify-content:flex-start; align-items:flex-start">        
             <div class="row-between" style="width:100%">
            <el-button v-if="steps[3].step && !steps[3].state" color="#6467F0" style="border:none" size="small" plain loading round>数据查询中</el-button>
            <el-button v-if="steps[3].step && steps[3].state" color="#6467F0" size="small" dark round>
             数据查询结果
            </el-button>
            
            </div>
            <div v-if="showQueryData" 
                 style="height:260px;width:100%; box-sizing: border-box;margin-top:5px;padding:8px; border-radius:4px;border:1px solid #E4EDEF">
                <el-auto-resizer>
                  <template #default="{height, width}">
                    <el-table-v2
                        :columns="columns"
                        :data="tableData"
                        :width="width"
                        :height="height"
                        fixed loading/>
                  </template>
                </el-auto-resizer>
              <div style="width:100%; padding:0px; box-sizing: border-box; margin-top:20px" class="row-end">
                <el-image src="/good.svg" style="margin-left:15px;width: 20px; height: 20px"/>
                <el-image src="/bad.png" style="margin-left:15px;width: 20px; height: 20px"/>
                <el-icon style="margin-left:15px; font-size:16px"><CopyDocument /></el-icon>
                <el-icon style="margin-left:15px; font-size:16px"><Delete /></el-icon>
                <el-icon style="margin-left:15px; font-size:16px"><Refresh /></el-icon>
                <el-icon style="margin-left:15px; font-size:16px"><Download /></el-icon>
              </div>
              </div>
             </div>

        </div>
      </div>
      </div>



    <div class="footer">
        
        
    
      <div style="margin-left:30%;width:40%;">
      <div v-if="suggestions.length > 0" 
         style="display: flex; flex-direction:column;border-radius:15px; box-shadow: --el-box-shadow-lighter; background-color:white; border:1px solid #E4E7ED;height:400px; overflow-y:auto">
         <div v-for="(sug, ii) in suggestions" style="padding:5px" :key="ii">
             <div v-if="sug.type=='描述'" style="color:#6467F0">{{sug.text}}</div>
             <div v-if="sug.type=='字段'" style="color:#F56C6C">{{sug.text}}</div>
         </div>
      </div>
      
      <div class="query-box" style="margin-top:10px">
        
        <textarea v-model="content" placeholder="输入要查询的问题"
               @keydown.enter="avoidEnter" @input="handleInput"
               class="input-box"/>
        <div class="row-between" style="width:100%;padding:0">
          <el-button class="row" style="color: #6467f0;background-color:#F4F4FE; border: none;margin-top:0px" @click="toCheckTablePage">
            <img src="/database.svg" style="width: 20px; height: 20px"/><span style="margin-left:5px">数据库管理</span>
          </el-button>
          <div v-if="sendLabel === '1'" class="row" style="height: 35px; width: 35px; border-radius: 50%; background-color: lightgray">
            <img src="/send.svg" style="width: 22px; height: 22px" @click="avoidEnter"/>
          </div>
          <div v-if="sendLabel === '2'" class="row" @click="stopGen"
               style="height: 35px; width: 35px; border-radius: 50%; background-color:white; border:3px solid #6467F0">
            <img src="/pause.svg" style="width: 18px; height: 18px"/>
          </div>
          <div v-if="sendLabel === '3'" class="row" style="height: 35px; width: 35px; border-radius: 50%; background-color: #6467F0">
            <img src="/send.svg" style="width: 22px; height: 22px" @click="avoidEnter"/>
          </div>
        </div>
      </div>
      </div>

        <div class="row" style="color:gray; font-size:14px; padding:5px; width:100%">- 内容由大模型生成，请注意甄别 -</div>
    </div>

  </el-container>
</template>

<script setup>
import {ref, onMounted, watch} from "vue";
import {fetchEventSource} from "@microsoft/fetch-event-source";
import axios from "axios";
import router from "@/router";
import {useStore} from "vuex";
const store = useStore();
const columns = ref([]);
const height = ref(50);
const width = ref(100);
const showQueryData = ref(false);
const tableData = ref([]);
const dialogues = ref([]);
const query = ref('');
const response = ref("");
const sendLabel = ref("1");
const content = ref("");
const contentRef = ref(null);
const mysql = ref("");
const prompt_id = ref("");
const trigger = ref("");
const think_content = ref("");
const match_content = ref("");
const sql_content = ref("");
const work_modes = ref('BI模式');
const suggestions = ref([]);

const options = [
  {
    value: '开发者模式',
    label: '开发者模式',
  },
  {
    value: 'BI模式',
    label: 'BI模式',
  }
]

const steps = ref([
  {step:false, state: false},
  {step:false, state: false},
  {step:false, state: false},
  {step:false, state: false},
]);

// const querySearchAsync = () =>{
//     const resp = axios.post('/vector', {
//             content:content.value, // 查询参数
//             coll_name: 'table_schema',
//             op: 'search'
//           },
//           {
//             headers: {
//               'Content-Type': 'application/json'
//             },
//           }
//       );
//     console.log(resp.data.response.data);
//     suggestions.value = resp.data.response.data;
// }


// let timer = null;
const handleInput = async() =>{
  sendLabel.value = '3';
  // clearTimeout(timer);
  // timer = setTimeout(() => {
  //   if(content.value.trim()) {
  //     axios.post('/vector',
  //        {
  //           content:content.value, // 查询参数
  //           coll_name: 'table_schema',
  //           op: 'suggestion'
  //         },
  //         {
  //           headers: {
  //             'Content-Type': 'application/json'
  //           },
  //         }
  //     ).then(res => suggestions.value = res.data.response)
  //   } else {
  //     suggestions.value = [];
  //   }
  // }, 300);
}

const executeMysql = async() =>{
  const resp = await axios.get('/db', {
        params: {
          mysql: mysql.value, // 查询参数
          mode: 'query', // 可以添加多个参数
        }
      }, {
        headers: {
          'Content-Type': 'application/json'
        },
      }
  );
  console.log(resp);
  columns.value = resp.data.columns;
  tableData.value = resp.data.response;
  mysql.value = resp.data.msg;
  if (mysql.value === ""){
    showQueryData.value = true;
  }
}

const toLoginPage = () =>{
  router.push('/login')
}

const goBack = () =>{
  router.back();
}

const toCheckTablePage = () =>{
  router.push('/checktable')
}

const sleep = (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms));
}

const avoidEnter = async(event) =>{
  if (event.key === "Enter"){
    event.preventDefault();
  }
  sendLabel.value = "2";
  query.value = content.value;
  content.value = '';
  response.value = '';
  showQueryData.value = false;
  if (work_modes.value === 'BI模式'){
    steps.value = [
      {step:false, state: false},
      {step:false, state: false},
      {step:false, state: false},
      {step:false, state: false},
    ];
    prompt_id.value = "118359fd-b5c8-48e7-968e-fd03a5314859"
    trigger.value = "#开始判别数据库查询问题#\n";
    steps.value[0].step = true;
    steps.value[0].state = false;
      
    match_content.value = '';
    sql_content.value = '';
    think_content.value = '';
    response.value = '';
    await queryTransform(0);
    if(response.value === "是"){
      prompt_id.value = "40591464-2c96-4057-9e08-04c404b9f3bc";

      response.value = '';
      const resp1 = await axios.post('/vector', {
            name: 'table_schema',
            op: 'recall_tables'
          },
          {
            headers: {
              'Content-Type': 'application/json'
            },
          }
      );
      trigger.value = "\n## 候选表格中文名称列表 ##\n" + resp1.data.response + "\n#开始输出查询转换#\n"
      await queryTransform(1);
      steps.value[0].state = true;
      steps.value[1].state = false;
      steps.value[1].step = true;
      await sleep(2000);
      const resp = await axios.post('/vector', {
            content: think_content.value, // 查询参数
            coll_name: 'table_schema',
            op: 'search'
          },
          {
            headers: {
              'Content-Type': 'application/json'
            },
          }
      );
      console.log("==========")
      console.log(resp.data.response);
      steps.value[1].state = true;
      steps.value[2].step = true;
      steps.value[2].state = false;
      prompt_id.value = '1dac3d6f-aa37-4e63-be25-5947dfd281ce';
      match_content.value = resp.data.response.match.join("\n");
      await sleep(2000);
      trigger.value = resp.data.response.data + "\n\n开始输出mysql语句->\n";
      console.log(trigger.value);
      await queryTransform(2);
      steps.value[2].state = true;
      mysql.value = sql_content.value;
      await sleep(2000);
      steps.value[3].step = true;
      steps.value[3].state = false;
      await executeMysql();
      steps.value[3].state = true;
      addDialogues();
      clear();
    }else{
      response.value = "您所描述的问题不涉及数据库查询！"
      sendLabel.value = "1";
      steps.value = [
        {step:false, state: false},
        {step:false, state: false},
        {step:false, state: false},
        {step:false, state: false},
      ];
    }
  }else{
    doDevlopMode();
  }
}

const doDevlopMode = async() =>{
  console.log("=======>")
  prompt_id.value = "85e7bbed-c971-461c-b9c1-c94e506527d4";
  trigger.value = "## 开始生成mysql语句 ##\n";
  // await subscribeToEvents();
}


const addDialogues = () =>{
  dialogues.value.push({"role": "user", "content": query.value});
  dialogues.value.push({"role": "query_think", "content": think_content.value});
  dialogues.value.push({"role": "query_match", "content": match_content.value});
  dialogues.value.push({"role": "assistant", "content": sql_content.value});
}

const clear = () =>{
  response.value = '';
  query.value = '';
  think_content.value = '';
  match_content.value = '';
  sql_content.value = '';
}


let ctrl = new AbortController();
const queryTransform = async (step) => {
  try {
    let mess = [];
    mess.push({"role": "user", "content": query.value})
    await fetchEventSource('/chat2users', {
      method: "POST",
      body: JSON.stringify({
        messages: mess,
        prompt_id: prompt_id.value,
        trigger: trigger.value
      }),
      headers: {
        'Content-Type': 'application/json'
      },
      signal: ctrl.signal,
      onopen: (resp) => {
        if (resp.ok && resp.status === 200) {
          console.log('Connection established');
        } else {
          console.error('Failed to connect:', resp);
        }
      },
      onmessage: (message) => {
        if (message.event === ''){
          if (step == 0){
             response.value += "  \r";
          }
            if (step == 1){
             think_content.value += "  \r";
          }
            if (step == 2){
             sql_content.value += "  \r";
          }
          
        }else{
            if (step == 0){
             response.value += message.data;
          }
            if (step == 1){
             think_content.value += message.data;
          }
            if (step == 2){
             sql_content.value += message.data;
          }
        }
      },
      onerror: (err) => {
        console.error('Error occurred:', err);
        if (ctrl && !ctrl.signal.aborted){
          ctrl.abort();
          ctrl = new AbortController();
        }
        sendLabel.value = "1";
      },
      onclose: () => {
        console.log('Connection closed');
        sendLabel.value = "1";
      },
      onfinish:() => {
        console.log('Finished receiving events');
        sendLabel.value = "1";
      }
    });
  } catch (err) {
    console.error('Unexpected error:', err);
  }
}



function handScroll(event){
  const {scrollTop, scrollHeight, clientHeight} = event.target;
  if (scrollTop && scrollHeight && clientHeight && scrollTop + clientHeight >= scrollHeight){
    contentRef.value.scrollTop = scrollHeight;
  }
}

function scrollToBottom(){
  if (contentRef.value){
    contentRef.value.scrollTop = contentRef.value.scrollHeight;
  }
}

watch(response,()=>{
  scrollToBottom();
})


onMounted(async ()=>{
  columns.value = [];
  height.value = 50;
  width.value = 100;
  tableData.value = [];
})
</script>

<style scoped>
    
:deep(.el-autocomplete .el-input__inner) {  
   border: none !important;  
   box-shadow: none !important; 
}  


.column{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
    
.aux-content{
  background-color:white;
  color:gray;
  border: 1px solid #E4E7ED;
  margin-top:5px;
  padding:10px 20px 20px 10px;
  width:100%;
  border-radius:8px;
  box-sizing:border-box;
  
}

.scroll-container{
  overflow: auto;
}

.scroll-container::-webkit-scrollbar {
  width: 2px; /* 设置宽度为0 */
}

/* 可选：进一步确保滚动条不可见 */
.scroll-container::-webkit-scrollbar-thumb {
  background: transparent;
}

.round-button{
  margin-left: 15px;
  width:40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid lightgray;
}

.round-button:hover{
  background-color: #6467f0;
  border: 1px solid #6467f0;
  color: white;
}

.header, .mid, .footer{
  width:100%;
  padding:15px;
  box-sizing: border-box;
}

.header {
  height: 70px;
}

.mid{
  flex-grow: 1.0;
}

.footer{
  height: auto;
  padding:0px 15px;
}

.input-box{
  resize:none;
  overflow:hidden;
  box-sizing:border-box;
  height:40px;
  width:99%;
  text-align: left;
  outline: none;
  border: 0px solid lightgray;
  font-size:16px;
}

.query-box{
  border-radius:15px;
  padding:10px 5px 5px 5px;
  border: 2px solid #E4E7ED;
  box-sizing: border-box;
}

.query-box:hover{
  border: 2px solid #6467f0;
}


.v-md-editor{
  padding: var(--v-md-editor-padding);
  border-radius: 15px;
  width: 100%;
  border:none;
  background-color: white;
  text-align: left;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.1);
  font-family: 'Arial', sans-serif;
}

.v-md-editor:hover{
  border:2px solid #6467F0;
}

.run-state{
  background-color:white;
  border-radius: 30px;
  font-size:16px;
  color:darkblue;
  border:none;
  opacity:1;
  font-weight: bold;
  margin-top:10px
}

.success-state{
  color:green;
  font-weight:bold;
  background-color:white;
  display: flex;
  flex-direction:row;
  justify-content:center;
  align-items:center;
  margin-top:15px
}

.select-input{
  --el-border-color: none;
  --el-border: 1px solid #6467F0;
}

</style>